import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';
import { dateToMidnightUTCObject } from '~/modules/common/dates/convert';
import { getTotalAllocatedHoursStartingFromDate } from '~/modules/resourcing/util';

export const getTotalHoursRemainingAsOfDate = ({
  releaseDateUtc,
  taskAllocationsSummary
}) => {
  if (!taskAllocationsSummary) return null;

  return getTotalAllocatedHoursStartingFromDate({
    date: releaseDateUtc,
    allocation: taskAllocationsSummary
  });
};

export const USER_ASSIGNED_IMPACTED_TASK_SUMMARY_QUERY = gql`
  query GetImpactedTaskDetailsSummary(
    $projectId: String!
    $releaseDate: Date2
    $filter: GetResourceUsersFilter!
    $includeMaxTaskEndDate: Boolean!
  ) {
    resourceUsers2(filter: $filter) {
      id
      displayText
      impactedTaskSummary(projectId: $projectId, releaseDate: $releaseDate) {
        taskUris
        maxTaskEndDate @include(if: $includeMaxTaskEndDate)
        taskAllocationsSummary {
          totalHours
          startDate
          endDate
          scheduleRules {
            dateRange {
              startDate
              endDate
            }
            do
          }
        }
      }
    }
  }
`;

const useGetUsersAssignedImpactedTaskSummary = ({
  includeMaxTaskEndDate = false,
  projectId,
  userIds,
  asOfDate,
  skip = false
}) => {
  const releaseDateUtc = asOfDate
    ? dateToMidnightUTCObject(asOfDate).plus({ days: 1 })
    : null;

  const { data, loading } = useQuery(
    USER_ASSIGNED_IMPACTED_TASK_SUMMARY_QUERY,
    {
      variables: {
        projectId,
        filter: {
          userIds
        },
        releaseDate: releaseDateUtc && releaseDateUtc.toISO(),
        includeMaxTaskEndDate
      },
      skip,
      fetchPolicy: 'network-only'
    }
  );

  const resourceUsers = get(data, 'resourceUsers2', []);

  return {
    usersAssignedImpactedTaskSummary: resourceUsers.map(user => {
      const { impactedTaskSummary } = user;

      return {
        ...user,
        impactedTaskSummary: {
          ...impactedTaskSummary,
          totalHoursRemainingAsOfDate: getTotalHoursRemainingAsOfDate({
            releaseDateUtc,
            taskAllocationsSummary: impactedTaskSummary?.taskAllocationsSummary
          })
        }
      };
    }),
    isLoading: loading
  };
};

export default useGetUsersAssignedImpactedTaskSummary;
